module.exports = __webpack_public_path__ + "img/huiyuan2.e4742eb7.jpg";